export class SelectListItemModel {
    name: string;
    value: string;
    description: string;

    constructor(name, value, description) {
        this.name = name;
        this.value = value;
        this.description = description;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/select-list-item.model.ts